export default __webpack_public_path__ + "static/media/station-point.c3ad7a27.svg";